export default __webpack_public_path__ + "static/media/herbalife1.010f1658.jpg";